// What the campaign page calls an ad (#6612). A Glitch ad is a Google Ads ad group, and imported ads carry no Glitch
// name, so they used to read "Ad 1", "Ad 2" beside Google Ads' own "CO2 Laser" and "Anti-Ageing". An ad with no Glitch
// name now goes by its ad group's name. Names Glitch generates for the ad groups it creates ("Gl-<url>-<uuid>") were
// never chosen by anyone, so those ads keep their position label. Pure functions, shared by the sidebar, the ad page
// and the campaign export.
import type { Ad } from '@/lib/types';

const GENERATED_AD_GROUP_NAME_PREFIX = 'Gl-';

type AdNameFields = Pick<Ad, 'name' | 'googleads_ad_group' | 'googleads_ad_group_name'>;

/**
 * The ad group's name as Google Ads has it, or null when none is known.
 *
 * The synced ad group row comes first: an imported ad's own ``googleads_ad_group_name`` column holds a name Glitch
 * generated at import, not the real one.
 */
export function googleAdsAdGroupName(ad: Pick<Ad, 'googleads_ad_group' | 'googleads_ad_group_name'>): string | null {
  return ad.googleads_ad_group?.name || ad.googleads_ad_group_name || null;
}

/** The label for an ad: its Glitch name, else its ad group's chosen name, else "Ad <position>" (1-based). */
export function adDisplayName(ad: AdNameFields, position: number): string {
  if (ad.name) return ad.name;
  const groupName = googleAdsAdGroupName(ad);
  if (groupName && !groupName.startsWith(GENERATED_AD_GROUP_NAME_PREFIX)) return groupName;
  return `Ad ${position}`;
}
